import { FC } from "react"
import Modal from ".."
import ModalHeader from "../ModalHeader"
import Button from "shared/Buttons/Button/Button"

interface IProps {
  entityName?: string
  onDelete: () => void
  onClose: () => void
}

const ConfirmDeleteModal: FC<IProps> = props => {
  return (
    <Modal size='sm' onClose={props.onClose}>
      <ModalHeader onClose={props.onClose}>Удалить {props.entityName}?</ModalHeader>
      <div className='modal-footer'>
        <Button  theme='danger' onClick={props.onDelete}>
          Удалить
        </Button>
        <Button  theme='grey-outline' onClick={props.onClose}>
          Отменить
        </Button>
      </div>
    </Modal>
  )
}

export default ConfirmDeleteModal
